import React from 'react'

function Footer() {
    return (
        <footer className='text-center' rel='noopener noreferrer'>Made by Alexoid. <span className='text-warning'>data API OMDb</span></footer>
    )
}

export default Footer
